import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useState } from 'react';
import { SuperAdminHeaderProvider } from '../../contexts/SuperAdminHeaderContext';
import { ToastProvider } from '../../contexts/ToastContext';
import ToastContainer from '../common/ToastContainer';
import styles from '../../assets/scss/layout/SuperAdminLayout.module.scss';
import sidebarStyles from '../../assets/scss/layout/SuperAdminSidebar.module.scss';
import SuperAdminHeader from './SuperAdminHeader';
import SuperAdminSidebar from './SuperAdminSidebar';

export default function SuperAdminLayout({ children }) {
    const [collapsed, setCollapsed] = useState(false);
    const [mobileOpen, setMobileOpen] = useState(false);

    const toggleCollapse = () => setCollapsed(!collapsed);
    const toggleMobile = () => setMobileOpen(!mobileOpen);

    return (
        <SuperAdminHeaderProvider>
        <ToastProvider>
            <div className={`${styles.layout}${collapsed ? ` ${styles.layoutCollapsed}` : ''}`}>
                {mobileOpen && (
                    <div
                        className={`${sidebarStyles.sidebarOverlay} ${sidebarStyles.sidebarOverlayVisible}`}
                        onClick={() => setMobileOpen(false)}
                    />
                )}

                <SuperAdminSidebar
                    collapsed={collapsed}
                    mobileOpen={mobileOpen}
                    onClose={() => setMobileOpen(false)}
                />
                <button
                    className={`${styles.sidebarEdgeToggle}${collapsed ? ` ${styles.sidebarEdgeToggleCollapsed}` : ''}`}
                    onClick={toggleCollapse}
                >
                    {collapsed ? <ChevronRight /> : <ChevronLeft />}
                </button>
                <SuperAdminHeader onMobileToggle={toggleMobile} collapsed={collapsed} />

                <div className={styles.layoutMain}>
                    <div className={styles.layoutContent}>
                        {children}
                    </div>
                </div>

                <ToastContainer />
            </div>
        </ToastProvider>
        </SuperAdminHeaderProvider>
    );
}
